import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ThemeAssetComponent } from '@partners/themes';
import { isFunction } from '@partners/utils';
import { TCssPosition } from '../../model';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
  selector: 'filled-button',
  standalone: true,
  template: `
    <button mat-button [disabled]="disabled || pending()" [type]="type" (click)="onClick($event)">
      @if (iconName()) {
      <theme-asset [asset]="iconName()" [size]="iconSize()"></theme-asset>
      }
      <ng-content></ng-content>
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClass()'
  },
  exportAs: 'filledButton',
  imports: [MatButtonModule, ThemeAssetComponent]
})
export class FilledButtonComponent extends BaseButtonComponent {
  iconPlacement = input<TCssPosition>('start');

  selfPosition = input<TCssPosition>('stretch');

  hostClass = computed(() => {
    return `button--filled button--icon-${this.iconPlacement()} button--position-${this.selfPosition()}`;
  });

  constructor() {
    super();
  }

  onClick(event: MouseEvent | TouchEvent) {
    if (this.type !== 'submit') {
      event.stopPropagation();
      event.preventDefault();

      /** let async fn service handle the click event to allow the manage of pending state */
      if (isFunction(this.clickFn())) {
        this._asyncClickService.runAsyncMethod(this.clickFn(), {
          pendingInd: this.pendingInd(),
          trailTime: this.clickFnTrailTime()
        });
      } 
      
      this.click.emit({ event: event, context: this.context });
    }

    this.changeDetector.markForCheck();
  }
}
